import { jsx as _jsx } from "react/jsx-runtime";
import { AccountDialogRoutes } from 'shared/account.settings/model/types';
import { DetailsPage } from 'console/features/account.settings/ui/details';
import { BalancePage } from 'console/features/account.settings/ui/balance';
import { AppConfigPage } from 'console/features/account.settings/ui/app-config';
import { UiConfigPage } from 'features/account.settings/ui/ui-config';
import { GuestModePage } from 'console/features/account.settings/ui/guest-mode';
import { PublicAccessPage } from 'console/features/account.settings/ui/public-access';
import { ArchivePage } from 'console/features/account.settings/ui/archive/archive';
import { AccessLogPage } from 'console/features/account.settings/ui/access-log/access-log';
import { AccountSettingsDialog } from 'pages/account.settings/ui';
import { IconPackSettingsPage } from 'features/account.settings/ui/icon-settings';
import { BillingHistoryPage } from 'features/account.settings/ui/billing_history/billing-history';
export const account_dialog_routes = [
    {
        path: `/${AccountDialogRoutes.account}`,
        element: _jsx(AccountSettingsDialog, {}),
        children: [
            {
                path: AccountDialogRoutes.details,
                element: _jsx(DetailsPage, {}),
            },
            {
                path: AccountDialogRoutes.balance,
                element: _jsx(BalancePage, {}),
            },
            {
                path: AccountDialogRoutes.app_config,
                element: _jsx(AppConfigPage, {}),
            },
            {
                path: AccountDialogRoutes.ui_config,
                element: _jsx(UiConfigPage, {}),
            },
            {
                path: AccountDialogRoutes.icons_settings,
                element: _jsx(IconPackSettingsPage, {}),
            },
            {
                path: AccountDialogRoutes.guest_mode,
                element: _jsx(GuestModePage, {}),
            },
            {
                path: AccountDialogRoutes.public_access,
                element: _jsx(PublicAccessPage, {}),
            },
            {
                path: AccountDialogRoutes.archive,
                element: _jsx(ArchivePage, {}),
            },
            {
                path: AccountDialogRoutes.access_log,
                element: _jsx(AccessLogPage, {}),
            },
            {
                path: AccountDialogRoutes.billing_history,
                element: _jsx(BillingHistoryPage, {}),
            },
        ],
    },
];
